import axios, { AxiosInstance } from "axios";
import history from "./history";
import { Token as token } from "./lib/ground-aws-graphql-core/store/provider";
import { EnumPaths } from "./utils/navigation";
import { asyncLocalStorage } from "./utils/token";

const signOut = () => {
  asyncLocalStorage.clear().then(() => {
    history.push(`/${EnumPaths.SIGNIN}`);
  });
};

const getInstance = (headers?: any): AxiosInstance => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_ENDPOINT,
    withCredentials: true,
    headers,
  });

  instance.interceptors.request.use(config => {
    const configWithAuthorization = { ...config };

    if (token)
      configWithAuthorization.headers.Authorization = `Bearer ${token}`;

    return configWithAuthorization;
  });

  // Response interceptors for API calls
  instance.interceptors.response.use(undefined, error => {
    if (
      error.response?.status === 401 &&
      (error.response?.data?.error?.error_code === "RefreshTokenException" ||
        error.response?.data?.error_code === "UnauthorizedException")
    ) {
      signOut();
    }

    return Promise.reject(error);
  });

  return instance;
};

// Request interceptors for API calls
// Needed because Safari doesn't allow third-party cookies

const axiosInstance = getInstance({
  "Content-Type": "application/json",
  Accept: "application/json",
});
const axiosInstanceMultipart = getInstance({
  "Content-Type": "multipart/form-data",
});
const axiosInstancePdf = getInstance({ "Content-Type": "application/pdf" });

export { axiosInstance, axiosInstanceMultipart, axiosInstancePdf };
